var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarAppliedJobIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_499_105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.51074 3.96903V2.62949C4.51074 2.09636 4.94695 1.66016 5.48008 1.66016H10.5207C11.0538 1.66016 11.49 2.09636 11.49 2.62949V3.96903",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35156 8.33105V13.4376C1.35156 13.934 1.75777 14.3401 2.25405 14.3401H6",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.31553 9.6785C2.77715 9.33097 0.75 8.46815 0.75 7.09005V4.95425C0.75 4.45719 1.1554 4.05176 1.65249 4.05176H14.3475C14.8446 4.05176 15.25 4.45722 15.25 4.95425L15.4644 6.11664",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2501 10.6001C15.2501 12.6628 13.5779 14.335 11.5152 14.335C9.45244 14.335 7.78027 12.6628 7.78027 10.6001C7.78027 8.53741 9.45244 6.86523 11.5152 6.86523C13.5779 6.86523 15.2501 8.53741 15.2501 10.6001Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0218 9.5791L10.9799 11.6211L10.0078 10.649",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_499_105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarAppliedJobIcon);
export default __webpack_public_path__ + "static/media/sidebar-applied-job-icon.4a06810dd880055b13b39370c8d8894f.svg";
export { ForwardRef as ReactComponent };